module.exports = __webpack_public_path__ + "assets/paypal-36f77a.svg";